"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIER_CONFIG = void 0;
/** Default tier mapping */
exports.DEFAULT_TIER_CONFIG = {
    1: 'Portfolio',
    2: 'Delivery Stream',
    3: 'Release Train',
    4: 'Team',
};
//# sourceMappingURL=sled.js.map